import { isEmpty } from "lodash";

import { getDuration, getFormattedDate } from "helpers";
import { processorsTypes } from "mappers";
import { Processors, Sponsors } from "types";

export const boardingStatuses = {
	BOARDING_UNASSIGNED: 11,
	BOARDING_IN_PROGRESS: 12,
};

export const getProcessorSpecificAssociationLabel = (
	processorSpecificInfo,
	sponsor,
	processor,
) => {
	if (processorSpecificInfo) {
		for (const key of Object.keys(processorSpecificInfo)) {
			if (
				key === processorsTypes.TSYS &&
				sponsor === Sponsors.Esquire.displayName
			) {
				return "TSYS Esquire Association";
			} else if (
				key === processorsTypes.TSYS &&
				sponsor === Sponsors.Evolve.displayName
			) {
				return "TSYS Evolve Association";
			} else if (
				key === processorsTypes.TSYS &&
				sponsor === Sponsors.Merrick.displayName
			) {
				return "TSYS Merrick Association";
			} else if (key === processorsTypes.FISERV_OMAHA) {
				return "Current SYS/PRIN";
			} else if (key === processorsTypes.FISERV_NORTH) {
				return "Bank ID";
			} else return;
		}
	}

	const getDefaultTitle = () => {
		if (processor === Processors.TSYS.displayName) {
			return "TSYS Esquire Association";
		} else if (
			processor === Processors.FiservOmahaFSP.displayName ||
			processor === Processors.FiservOmahaRetail.displayName
		) {
			return "Current SYS/PRIN";
		} else if (processor === Processors.FiservNorth.displayName) {
			return "Bank ID";
		} else {
			return "TSYS Esquire Association";
		}
	};

	return getDefaultTitle();
};

export const getProcessorSpecificAssociationValue = (
	processorSpecificInfo,
	sponsor,
) => {
	if (processorSpecificInfo) {
		for (const key of Object.keys(processorSpecificInfo)) {
			if (
				key === processorsTypes.TSYS &&
				sponsor === Sponsors.Esquire.displayName
			) {
				return `${processorSpecificInfo[key].esquire_association}`;
			} else if (
				key === processorsTypes.TSYS &&
				sponsor === Sponsors.Evolve.displayName
			) {
				return `${processorSpecificInfo[key].evolve_association}`;
			} else if (
				key === processorsTypes.TSYS &&
				sponsor === Sponsors.Merrick.displayName
			) {
				return `${processorSpecificInfo[key].merrick_association}`;
			} else if (key === processorsTypes.FISERV_OMAHA) {
				return `${processorSpecificInfo[key]?.current_sys_prin || ""}`;
			} else if (key === processorsTypes.FISERV_NORTH) {
				return `${processorSpecificInfo[key].bank_id}`;
			} else return;
		}
	}
};

export const getProcessorSpecificRepCodeLabel = (
	processorSpecificInfo,
	processor,
) => {
	if (!isEmpty(processorSpecificInfo)) {
		for (const key of Object.keys(processorSpecificInfo)) {
			if (
				key === processorsTypes.TSYS ||
				key === processorsTypes.FISERV_OMAHA
			) {
				return "Rep Code";
			} else if (key === processorsTypes.FISERV_NORTH) {
				return "Corp ID";
			} else return "Rep Code";
		}
	} else {
		return processor === Processors.FiservNorth.displayName
			? "Corp ID"
			: "Rep Code";
	}
};

export const getProcessorSpecificRepCodeValue = processorSpecificInfo => {
	if (processorSpecificInfo) {
		for (const key of Object.keys(processorSpecificInfo)) {
			if (key === processorsTypes.TSYS) {
				return `${processorSpecificInfo[key]?.rep_code_one || ""}`;
			} else if (key === processorsTypes.FISERV_OMAHA) {
				return `${processorSpecificInfo[key]?.rep_code_two || ""}`;
			} else if (key === processorsTypes.FISERV_NORTH) {
				return `${processorSpecificInfo[key]?.corp_id || ""}`;
			} else return;
		}
	}
};

export const getProcessorSpecificRepIdValue = processorSpecificInfo => {
	if (processorSpecificInfo) {
		for (const key of Object.keys(processorSpecificInfo)) {
			if (key === processorsTypes.FISERV_NORTH) {
				return `${processorSpecificInfo[key]?.rep_id || ""}`;
			} else return;
		}
	}
};

export const getBoardingAge = boardingStart => {
	return getFormattedDate({ date: boardingStart });
};

export const getBoardingDurationAge = (boardingStart, boardingCompleted) => {
	const duration = getDuration({
		start: boardingStart,
		end: boardingCompleted,
	});

	return duration;
};
